<template>
    <div class="container" role="tablist">
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="text-nowrap font-weight-bold m-0">Contact Page Content</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue v-b-toggle.pageContent icon="eye"
                                  class="pointer"></icon-vue>
                    </div>
                    <b-collapse ref="collapse" class="mt-3 col-12" id="pageContent" accordion="accordion-1">
                        <hr>
                        <div>
                            <b-form @submit.prevent="updateData(dbRefs.contactRef, contactContent)">
                                <b-form-group
                                        id="grp-title"
                                        label="Page Heading"
                                        label-for="input-title"
                                        description="This is text that appears atop the contact page"
                                >
                                    <b-form-input
                                            id="input-1"
                                            v-model="contactContent.pageContent.title"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-subtitle"
                                        label="Page Sub-Heading"
                                        label-for="input-subtitle"
                                        description="This is text that appears below the heading"
                                >
                                    <b-form-input
                                            id="input-subtitle"
                                            v-model="contactContent.pageContent.subtitle"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-contactFormTitle"
                                        label="Contact Form Heading"
                                        label-for="input-contactFormTitle"
                                        description="This is text that appears right before the contact form"
                                >
                                    <b-form-input
                                            id="input-contactFormTitle"
                                            v-model="contactContent.pageContent.contactFormTitle"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-closing"
                                        label="Call to Action Text"
                                        label-for="input-closing"
                                >
                                    <b-form-input
                                            id="input-closing"
                                            v-model="contactContent.pageContent.closing"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-mapTitle"
                                        label="Map Heading"
                                        label-for="input-mapTitle"
                                        description="This is text that appears right before the map"
                                >
                                    <b-form-input
                                            id="input-mapTitle"
                                            v-model="contactContent.pageContent.mapTitle"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-mapSubtitle"
                                        label="Map Sub-Heading"
                                        label-for="input-mapSubtitle"
                                        description="This is text that appears below the map heading"
                                >
                                    <b-form-input
                                            id="input-mapSubtitle"
                                            v-model="contactContent.pageContent.mapSubtitle"
                                    ></b-form-input>
                                </b-form-group>
                                <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                          :disabled="saving">
                                    Save
                                </b-button>
                            </b-form>
                        </div>

                    </b-collapse>
                </div>
            </div>
        </div>


        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="font-weight-bold m-0 text-nowrap">Contact Information</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue v-b-toggle.contact-info icon="eye" class="pointer"></icon-vue>
                    </div>
                    <b-collapse ref="contact-info" class="mt-3 col-12" id="contact-info" accordion="accordion-1">
                        <hr>
                        <div>
                            <b-form @submit.prevent="updateData(dbRefs.contactRef, contactContent)">
                                <b-form-group
                                        id="grp-email"
                                        label="Email"
                                        type="email"
                                        label-for="input-email"
                                >
                                    <b-form-input
                                            id="input-email"
                                            v-model="contactContent.contactInfo.email"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-phone"
                                        label="Phone"
                                        label-for="input-phone"
                                >
                                    <b-form-input
                                            id="input-phone"
                                            v-model="contactContent.contactInfo.phone"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-strAddr"
                                        label="Street Address"
                                        label-for="input-strAddr"
                                >
                                    <b-form-input
                                            id="input-strAddr"
                                            placeholder="13 Bond Street, Leicester"
                                            v-model="contactContent.contactInfo.strAddr"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-city"
                                        label="City"
                                        label-for="input-city"
                                >
                                    <b-form-input
                                            id="input-city"
                                            v-model="contactContent.contactInfo.city"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-postalCode"
                                        label="Postal Code"
                                        label-for="input-postalCode"
                                >
                                    <b-form-input
                                            id="input-postalCode"
                                            v-model="contactContent.contactInfo.postalCode"
                                    ></b-form-input>
                                </b-form-group>
                                <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                          :disabled="saving">
                                    Save
                                </b-button>
                            </b-form>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="font-weight-bold m-0 text-nowrap">Office Hours</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue v-b-toggle.office-hrs icon="eye" class="pointer"></icon-vue>
                    </div>
                    <b-collapse ref="office-hrs" class="mt-3 col-12" id="office-hrs" accordion="accordion-1">
                        <hr>
                        <div>
                            <b-form @submit.prevent="updateData(dbRefs.contactRef, contactContent)">
                                <b-form-group
                                        id="grp-timeStart"
                                        label="Time Start"
                                        label-for="input-timeStart"
                                >
                                    <b-form-input
                                            id="input-timeStart"
                                            v-model="contactContent.officeHours.timeStart"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-timeEnd"
                                        label="Time End"
                                        label-for="input-timeEnd"
                                >
                                    <b-form-input
                                            id="input-timeEnd"
                                            v-model="contactContent.officeHours.timeEnd"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-dayStart"
                                        label="Day Start"
                                        label-for="input-dayStart"
                                >
                                    <b-form-input
                                            id="input-dayStart"
                                            v-model="contactContent.officeHours.dayStart"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group
                                        id="grp-dayEnd"
                                        label="Day End"
                                        label-for="input-dayEnd"
                                >
                                    <b-form-input
                                            id="input-dayEnd"
                                            v-model="contactContent.officeHours.dayEnd"
                                    ></b-form-input>
                                </b-form-group>
                                <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                          :disabled="saving">
                                    Save
                                </b-button>
                            </b-form>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
        <b-collapse ref="dirCollapse"
                    id="dirCollapse"
                    class="row no-gutters mb-5"
                    accordion="accordion-1"
                    v-model="showDirCollapse">
            <div class="col-12 col-sm-8 offset-sm-2 border rounded p-3">
                <div class="mb-2 d-flex justify-content-between">
                    <h5>{{!toBeEditedDir ? 'Add' : 'Edit'}} a Direction</h5>
                    <icon-vue
                            class="pointer text-danger"
                            icon="times-circle"
                            @click="showDirCollapse = false"
                    ></icon-vue>
                </div>
                <div>
                    <b-form @submit.prevent="saveDirection">
                        <b-form-group id="grp-dir"
                                      label="Description"
                                      label-for="input-dir">
                            <b-form-textarea
                                    id="input-dir"
                                    v-model="newDirection"
                                    rows="9"
                            ></b-form-textarea>
                        </b-form-group>
                        <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success"
                                  :disabled="saving">
                            Save
                        </b-button>
                    </b-form>
                </div>
            </div>
        </b-collapse>
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="font-weight-bold m-0 text-nowrap">Directions</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-3" small></b-spinner>
                        <icon-vue icon="plus-circle" class="pointer mr-3 text-success"
                                  @click="showDirCollapse = true"></icon-vue>
                        <icon-vue v-b-toggle.dirs icon="eye" class="pointer"></icon-vue>
                    </div>
                    <b-collapse ref="dirs" class="mt-3 col-12" id="dirs" accordion="accordion-1">
                        <hr>
                        <div v-for="(direction, index) in contactContent.directions" :key="index"
                             class="text-secondary p-2 border-bottom position-relative">
                            <div class="position-absolute actions">
                                <icon-vue :icon="['far', 'edit']" class="pointer mr-3"
                                          @click="editDir(direction)"></icon-vue>
                                <icon-vue
                                        class="pointer text-danger"
                                        icon="trash"
                                        @click="deleteDirection(dbRefs.contactRef, 'directions', direction)"></icon-vue>
                            </div>
                            <small class="w-90 d-block">{{direction}}</small>
                        </div>
                        <div class="p-3 text-center w-100" v-if="contactContent.directions.length < 1">
                            <small class="text-secondary">No directions added. <span
                                    class="text-dark  pointer" @click="showDirCollapse = true">Add one now</span>
                            </small>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { EventBus } from '../../eventBus';
  import { defaultContactContent } from '../../utils/content';
  import DataStreamListener from '../../mixins/dataListener';
  import AddDataHandler from '../../mixins/genericAddDataHandler';

  export default {
    data(){
      return {
        contactContent: { ...defaultContactContent },
        showDirCollapse: false,
        toBeEditedDir: '',
        newDirection: ''
      };
    },
    mixins: [DataStreamListener, AddDataHandler],
    methods: {
      async saveDirection(){
        let target = null;
        try{
          target = window.event.target.querySelector('button');
          this.showLoader(target);
          if(!this.toBeEditedDir){
            await this.saveToArray({ ...this.editDirPayload, value: this.newDirection, resetForm: false });
            this.newDirection = '';
            return true;
          }
          await this.updateDirection();
        }catch(e){
          this.$toasted.error(e.message || 'Something went wrong');
        }finally{
          this.hideLoader(target);
        }
      },
      editDir(dir){
        this.newDirection = dir;
        this.toBeEditedDir = dir;
        this.showDirCollapse = true;
      },
      async updateDirection(){
        const payload = {
          ref: this.dbRefs.contactRef,
          key: 'directions',
          beforeVal: this.toBeEditedDir,
          afterVal: this.newDirection
        };
        await this.updateArrayElem(payload);
        this.newDirection = '';
        this.showDirCollapse = false;

      },
      async deleteDirection(ref, key, value){
        await this.removeFromArray({ ref, key, value });
      }
    },
    computed: {
      editDirPayload(){
        return {
          ref: this.dbRefs.contactRef,
          key: 'directions'
        };
      }
    },
    watch: {
      showDirCollapse: function(newValue, oldValue){
        if(!newValue){
          this.toBeEditedDir = '';
          this.newDirection = '';
        }
      }
    },
    async mounted(){
      this.fetchSingleData(this.dbRefs.contactRef, defaultContactContent);
      EventBus.$on('dataFetched', contactContent =>{
        this.contactContent = contactContent;
        setTimeout(() =>{
          this.fetching = false;
        }, 1000);
      });
    }
  };
</script>

<style lang="scss" scoped="">
    .actions {
        right: 0;
    }
</style>